/* eslint-disable camelcase */
import qs from 'qs';
import { UPDATE_QUERY } from '../constants';

const initialLocationState = {
  query: {},
  presets: {},
};

// gclid is used for google analytics to determine if a customer was refered from paid google ads
const getQueryParamsToKeep = () => {
  const {
    gclid,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return {
    gclid,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  };
};

const getQueryState = (state, action) => {
  const newState = {
    ...state,
    query: {
      ...state.query,
    },
  };

  const payload = action?.payload || {};

  Object.keys(payload).forEach((key) => {
    newState.query[key] = payload[key];
  });

  newState.query = {
    ...newState.query,
    ...getQueryParamsToKeep(),
  };

  /* Om man skickar in tomt för en query-parameter så
  ska vi ta bort den ur url:en. Detta för att inte ha kvar
  tomma värden, t.ex. &filterValue= */
  Object.keys(newState.query).forEach((key) => {
    if (newState.query[key] === '' || newState.query[key] === undefined) delete newState.query[key];
  });

  return newState;
};

const locationReducer = (state = initialLocationState, action) => {
  const { type } = action;

  switch (type) {
    case UPDATE_QUERY:
      return getQueryState(state, action);

    default: return state;
  }
};

export default locationReducer;
